///<reference path="./Frame.js"/>
if (!!window._logHistory) throw "_logHistory already defined";
var _logHistory = [];
var _maxLogHistory = 100;
var consoleLogOverride;
// Log to the log window
function log(msg, severity) {
  var text = "";
  if (!severity) {
    severity = "info";
  }
  severity = severity.toLowerCase();
  if (msg) {
    if (msg.stack) {
      text = msg.stack;
    } else if (msg.message) {
      text = msg.message;
    } else {
      text = msg;
    }
  }
  // Call the console log override if it exists
  if (consoleLogOverride && typeof consoleLogOverride === 'function') {
    try { consoleLogOverride(text, severity); }catch(e) {}
  } 
  switch (severity) {
    case "warning":
    case "userwarning":
    case "error":
    case "fault":
    case "usererror":
      if (_logHistory.length >= _maxLogHistory) {
        _logHistory.shift();
      }
      _logHistory.push(JSON.stringify(text));
  }
  if (window.console && (runtimeMode == "Development" || instance.dframe)) {
    try {
      if (window.console) {
        switch (severity) {
          case "info":
          case "success":
            if (window.console.info) window.console.info(text);
            break;
          case "warning":
          case "userwarning":
            if (window.console.warn) window.console.warn(text);
            break;
          case "error":
          case "fault":
          case "usererror":
            if (window.console.error) window.console.error(text);
            break;
        }
      }
    } catch (err) {}
  }
}
